import { StrategyDeal } from 'model/modules/strategies/strategies';
import mapCurrencyFromApi from 'rtkQuery/sharespro/mapper/shared/mapCurrencyFromApi';

const mapStrategyDealFromApi = (api: ApiDeal, accountId: number): StrategyDeal => {
  const currency = mapCurrencyFromApi(api.currency);

  return {
    ticker: api.ticker,
    quantity: api.quantity,
    dateOpen: api.date_open,
    priceOpen: api.price_open,
    amountOpen: api.amount_open,
    feeOpen: api.fee_open,
    dateClose: api.date_close,
    priceClose: api.price_close,
    amountClose: api.amount_close,
    feeClose: api.fee_close,
    feeTotal: api.fee_total,
    profit: api.profit,
    profitPercent: api.profit_percent,
    clearedProfit: api.cleared_profit,
    clearedProfitPercent: api.cleared_profit_percent,
    currency,
    accountId,
  };
};

export default mapStrategyDealFromApi;
